module.exports = __webpack_public_path__ + "static/timeslot-10-minute-896b328f34e46838272637db538e562c.png";